export function trimPhoneNumber(value: string | null | undefined): string | null {
   return value?.replace(/[^\d]/g, '') ?? null;
}
